import { Box } from '@mui/material'
import React from "react";

interface ITextProps {
  notice?: number;
}

export const NoticeBadge: React.VFC<ITextProps> = ({ notice, ...props }): JSX.Element => {
  if (notice && notice !== 0) {
    return (
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: '#1F4266',
          borderRadius: '50%',
          color: 'white',
          display: 'flex',
          fontSize: 'small',
          fontWeight: 'bold',
          height: '22px',
          width: '22px',
          justifyContent: 'center',
          lineHeight: 'normal',
          marginLeft: '10px'
        }}
        {...props}
      >
        {notice > 99 ? "99+" : notice}
      </Box>
    )
  }
  return <></>;
};